// updateItemStatus
import { produce } from "immer";
import {
    ADD_USER, ADD_USER_SUCCESS, SAVE_USER_FAILURE,
    ADD_CATEGORY, ADD_CATEGORY_SUCCESS, SAVE_CATEGORY_FAILURE,
    DELETE_USER, DELETE_USER_SUCCESS,
    EDIT_USER, UPDATE_USER, UPDATE_CATEGORY, UPDATE_ITEM_MENU, UPDATE_ITEM_STATUS_MENU,
    EDIT_USER_SUCCESS,
    EDIT_CATEGORY,
    EDIT_CATEGORY_SUCCESS,
    DELETE_CATEGORY, DELETE_CATEGORY_SUCCESS,
    GENERATE_LOGIN_OTP_SUCCESS,
    SEND_LOGIN_OTP,
    SEND_LOGIN_OTP_SUCCESS,
    FETCH_USERS_SUCCESS,
    FETCH_CATEGORIES_SUCCESS,
    API_FETCH_MENU_iTEM_SUCCESS,
    ADD_NOTE, ADD_MENU_ITEM, UPDATE_MENU_ITEM, SAVE_MENU_ITEM_FAILURE,
    REMOVE_ITEM_MENU, REMOVE_ITEM_MENU_SUCCESS,
    EDIT_MENU_ITEM,
    ADD_ITEM_MENU_SUCCESS,
    EDIT_MENU_ITEM_SUCCESS,
    FETCH_LIVE_ORDERS,
    FETCH_LIVE_ORDER_SUCCESS,
    FETCH_LIVE_ORDER_FAILURE,
    FETCH_ORDER_HISTORY_BY_TABLEOTP,
    FETCH_ORDER_HISTORY,
    FETCH_ORDER_HISTORY_SUCCESS,
    FETCH_ORDER_HISTORY_FAILURE,
    UPDATE_ORDER_STATUS,
    UPDATE_ORDER_STATUS_SUCCESS,
    UPDATE_ORDER_STATUS_FAILURE,
    FETCH_CANCEL_ORDER,
    FETCH_CANCEL_ORDER_SUCCESS,
    FETCH_CANCEL_ORDER_FAILURE,
    ADD_TABLE_NUMBER,
    ADD_TABLE_NUMBER_SUCCESS,
    ADD_TABLE_NUMBER_FAILURE,
    FETCH_TABLES,
    FETCH_TABLES_SUCCESS,
    FETCH_TABLES_FAILURE,
    DELETE_TABLE, DELETE_TABLE_SUCCESS,
    DELETE_TABLE_FAILURE,
    EDIT_TABLE,
    EDIT_TABLE_SUCCESS,
    EDIT_TABLE_FAILURE,
    FETCH_RESTAURANT_DETAIL_REQUEST,
    FETCH_RESTAURANT_DETAIL_SUCCESS,
    FETCH_RESTAURANT_DETAIL_FAILURE,
    UPDATE_RESTAURANT_PROFILE_REQUEST,
    UPDATE_RESTAURANT_PROFILE_SUCCESS,
    UPDATE_RESTAURANT_PROFILE_FAILURE,
    FETCH_TAX_REQUEST,
    FETCH_TAX_SUCCESS,
    FETCH_TAX_FAILURE,
    UPDATE_TAX_REQUEST,
    UPDATE_TAX_SUCCESS,
    UPDATE_TAX_FAILURE,
    FETCH_TABLES_WITH_OTP,
    UPDATE_TABLE_STATUS_REQUEST,
    UPDATE_TABLE_STATUS_SUCCESS,
    UPDATE_TABLE_STATUS_FAILURE,
    FETCH_LIVE_ORDERS_BY_TABLEOTP,
    PLACE_ORDER_FOR_TABLE,
    PLACE_ORDER_SUCCESS,
    PLACE_ORDER_FAILURE,
    FETCH_BILL_REQUEST,
    FETCH_BILL_SUCCESS,
    RESET_SAVED_BILL,
    SAVE_BILL_REQUEST,
    SAVE_BILL_SUCCESS,
    SAVE_BILL_FAILURE,
    FETCH_BILLS,
    FETCH_BILLS_SUCCESS,
    FETCH_BILLS_FAILURE,
    FETCH_BILL_ITEM,
    FETCH_BILL_ITEM_SUCCESS,
    FETCH_BILL_ITEM_FAILURE,
    GET_RESERVATIONS_REQUEST,
    GET_RESERVATIONS_SUCCESS,
    GET_RESERVATIONS_FAILURE,
    CREATE_RESERVATION_REQUEST,
    CREATE_RESERVATION_SUCCESS,
    SAVE_RESERVATION_FAILURE,
    UPDATE_RESERVATION_REQUEST,
    UPDATE_RESERVATION_SUCCESS,
    EDIT_RESERVATION,
    FETCH_DASHBOARD,
    FETCH_DASHBOARD_SUCCESS,
    CHANGE_PASSWORD,
    FETCH_SERVICE_REQUEST,
    FETCH_SERVICE_REQUEST_SUCCESS,
    UPDATE_SERVICE_REQUEST,
    UPDATE_SERVICE_REQUEST_SUCCESS,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_USER_DETAILS,
    EDIT_BANNER,
    API_FETCH_BANNER_SUCCESS,
    ADD_BANNER, ADD_BANNER_SUCCESS, SAVE_BANNER_FAILURE,
    DELETE_BANNER, DELETE_BANNER_SUCCESS,
    UPDATE_BANNER_STATUS, UPDATE_BANNER_STATUS_SUCCESS, UPDATE_BANNER_STATUS_FAILURE,
    EDIT_BANNER_SUCCESS,
    UPDATE_BANNER_SUCCESS,
    UPDATE_BANNER,
    FETCH_GALLERY_IMAGE_SUCCESS,
    FETCH_ADDON_GROUPS,
    SET_ADDON_GROUPS,
    FETCH_CATEGORY_ADDON_MAPPINGS,
    SET_CATEGORY_ADDON_MAPPINGS,
    CLEAR_CATEGORY_ADDON_MAPPINGS,
    FETCH_MENU_ITEM_ADDON_MAPPINGS,
    SAVE_ADDON_GROUP,
    SAVE_ADDON_GROUP_SUCCESS,
    SAVE_ADDON_GROUP_FAILURE,
    DELETE_ADDON_GROUP, DELETE_ADDON_GROUP_SUCCESS, DELETE_OPERATION_FAILURE,
    EDIT_ADDON_GROUP,
    CLEAR_MENU_ITEM_ADDON_MAPPINGS,
    SET_MENU_ITEM_ADDON_MAPPINGS

} from "./constant";


const initialState = {
    get: {}, update: {}, delete: {}, add: {}, updateStatus: {}, users: [], edit: {}, flags: {}, categories: [], foodItems: [],
    liveOrder: [], orderHistory: [], cancelledOrder: [], tables: [], error: null, loading: false, restaurant: null, tax: null,
    bill: [], savedBill: null, bills: [], billItem: [], reservations: [], saveReservations: [], dashboard: {}, loading: false,
    banners: [], bannerSaving: false, bannerStatusSavingIds: [], categorySaving: false, reservationSaving: false, userSaving: false,
    addonGroups: [], editAddonGroup: {}, addonSaving: false, addonSaveError: null,
    deleteSaving: false, deleteError: null, tableSaving: false,
    menuItemSaving: false, menuItemSaveError: null,
    addonGroupsLoading: false,
    categoryAddonGroupIds: [], categoryAddonMappingsLoading: false, categoryAddonMappingsFor: null,
    menuItemAddonMappings: [], menuItemAddonMappingsLoading: false, menuItemAddonMappingsFor: null
};

function reducers(state = initialState, action) {

    switch (action?.type) {
      case FETCH_MENU_ITEM_ADDON_MAPPINGS:
        return {
          ...state,
          menuItemAddonMappings: [],
          menuItemAddonMappingsLoading: true,
          menuItemAddonMappingsFor: action.payload,
        };

      case SET_MENU_ITEM_ADDON_MAPPINGS:
        return {
          ...state,
          menuItemAddonMappings: action.payload?.mappings || [],
          menuItemAddonMappingsLoading: false,
          menuItemAddonMappingsFor: action.payload?.menuId || null,
        };

      case CLEAR_MENU_ITEM_ADDON_MAPPINGS:
         return {
            ...state,
            menuItemAddonMappings: [],
            menuItemAddonMappingsLoading: false,
            menuItemAddonMappingsFor: null,
       };
      case FETCH_CATEGORY_ADDON_MAPPINGS:
        return {
          ...state,
          categoryAddonGroupIds: [],
          categoryAddonMappingsLoading: true,
          categoryAddonMappingsFor: action.payload,
        };
      case SET_CATEGORY_ADDON_MAPPINGS:
        return {
          ...state,
          categoryAddonGroupIds: action.payload?.groupIds || [],
          categoryAddonMappingsLoading: false,
          categoryAddonMappingsFor: action.payload?.categoryId || null,
        };
      case CLEAR_CATEGORY_ADDON_MAPPINGS:
        return {
          ...state,
          categoryAddonGroupIds: [],
          categoryAddonMappingsLoading: false,
          categoryAddonMappingsFor: null,
        };
      case FETCH_ADDON_GROUPS:
        return {
          ...state,
          addonGroupsLoading: true,
        };
      case SET_ADDON_GROUPS:
             return {
                ...state,
                addonGroups: Array.isArray(action.payload) ? action.payload : [],
                addonGroupsLoading: false,
    };

      case SAVE_ADDON_GROUP:
        return {
          ...state,
          addonSaving: true,
          addonSaveError: null,
        };

      case SAVE_ADDON_GROUP_SUCCESS:
        return {
          ...state,
          addonSaving: false,
          addonSaveError: null,
          editAddonGroup: {},
        };

      case SAVE_ADDON_GROUP_FAILURE:
        return {
          ...state,
          addonSaving: false,
          addonSaveError: action.payload,
        };

      case DELETE_USER:
      case DELETE_CATEGORY:
      case REMOVE_ITEM_MENU:
      case DELETE_TABLE:
      case DELETE_BANNER:
      case DELETE_ADDON_GROUP:
        return {
          ...state,
          deleteSaving: true,
          deleteError: null,
        };

      case DELETE_OPERATION_FAILURE:
        return {
          ...state,
          deleteSaving: false,
          deleteError: action.payload,
        };

      case DELETE_ADDON_GROUP_SUCCESS:
        return {
          ...state,
          deleteSaving: false,
          deleteError: null,
        };

      case EDIT_ADDON_GROUP:
           return {
            ...state,
            editAddonGroup: action.payload,
            addonSaveError: null,
     };  
      case FETCH_GALLERY_IMAGE_SUCCESS:
            return { ...state, loading: false, get: action.payload };
      case API_FETCH_BANNER_SUCCESS:
        return {
            ...state,
            banners: Array.isArray(action.payload) ? action.payload : Object.values(action.payload)
        };

      case ADD_BANNER:
        return { ...state, bannerSaving: true };

      case ADD_BANNER_SUCCESS:
    // 1. Force the current state into an array structure regardless of its current state
    const currentList = Array.isArray(state.banners) 
        ? state.banners 
        : Object.values(state.banners || {});

    return {
        ...state,
        // 2. Prepend the new banner item and keep it a clean, un-keyed Array!
        banners: [action.payload, ...currentList],
        bannerSaving: false,
        loading: false,
        error: null
    };

      case DELETE_BANNER_SUCCESS:
    // 1. Force state to a clean array format safely
    const currentBannersList = Array.isArray(state.banners) 
        ? state.banners 
        : Object.values(state.banners || {});
        
    return {
        ...state,
        // 2. Check for both t.bannerId AND t.id to catch any casing or naming variations!
        banners: currentBannersList.filter(
            (t) => t.bannerId !== action.payload && t.id !== action.payload
        ),
        deleteSaving: false,
        deleteError: null,
        loading: false,
        error: null
    };

      case UPDATE_BANNER_STATUS:
        return {
          ...state,
          banners: (Array.isArray(state.banners) ? state.banners : Object.values(state.banners || {})).map((banner) =>
            banner.bannerId === action.payload.bannerId
              ? { ...banner, displayOnMenu: action.payload.displayOnMenu }
              : banner
          ),
          bannerStatusSavingIds: [
            ...(state.bannerStatusSavingIds || []).filter((id) => id !== action.payload.bannerId),
            action.payload.bannerId,
          ],
        };

      case UPDATE_BANNER_STATUS_SUCCESS:
        return {
          ...state,
          banners: (Array.isArray(state.banners) ? state.banners : Object.values(state.banners || {})).map((banner) =>
            banner.bannerId === action.payload.bannerId
              ? { ...banner, displayOnMenu: action.payload.displayOnMenu }
              : banner
          ),
          bannerStatusSavingIds: (state.bannerStatusSavingIds || []).filter((id) => id !== action.payload.bannerId),
        };

      case UPDATE_BANNER_STATUS_FAILURE:
        return {
          ...state,
          banners: (Array.isArray(state.banners) ? state.banners : Object.values(state.banners || {})).map((banner) =>
            banner.bannerId === action.payload.bannerId
              ? { ...banner, displayOnMenu: action.payload.previousDisplayOnMenu }
              : banner
          ),
          bannerStatusSavingIds: (state.bannerStatusSavingIds || []).filter((id) => id !== action.payload.bannerId),
          error: action.payload.error,
        };

      case EDIT_BANNER:
            return {
                ...state,
                edit: action.payload
            }

        case EDIT_BANNER_SUCCESS:
            return {
                ...state,
                banners: {
                    ...action.payload  // update by userId
                },
                edit: {} // clear edit form
            }

         case UPDATE_BANNER:
            return {
                ...state,
                loading: true,
                bannerSaving: true,
                error: null
            };

        case UPDATE_BANNER_SUCCESS:
            return {
                ...state,
                loading: false,
                bannerSaving: false,
                banners: (Array.isArray(state.banners) ? state.banners : Object.values(state.banners || {})).map((banner) =>
                    banner.bannerId === action.payload.bannerId ? { ...banner, ...action.payload } : banner
                )
            };

        case SAVE_BANNER_FAILURE:
            return { ...state, bannerSaving: false, error: action.payload };

        case RESET_PASSWORD:
        case FETCH_SERVICE_REQUEST:
            return { ...state, loading: true };

        case FETCH_SERVICE_REQUEST_SUCCESS:
            return { ...state, loading: false, get: action.payload };

        case UPDATE_SERVICE_REQUEST:
            return { ...state, loading: true };

        case UPDATE_SERVICE_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                get: action.payload,
            };

        case EDIT_RESERVATION:
            return {
                ...state,
                edit: action.payload
            };

        case UPDATE_RESERVATION_REQUEST:
            return { ...state, loading: true, reservationSaving: true };

        case UPDATE_RESERVATION_SUCCESS:
            return {
                ...state,
                loading: false,
                reservationSaving: false,
                saveReservations: action.payload,
                edit: {}
            };

        case GET_RESERVATIONS_REQUEST:
            return { ...state, loading: true };

        case GET_RESERVATIONS_SUCCESS:
            return { ...state, loading: false, reservations: action.payload };

        case GET_RESERVATIONS_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case CREATE_RESERVATION_REQUEST:
            return { ...state, loading: true, reservationSaving: true };

        case CREATE_RESERVATION_SUCCESS:
            return {
                ...state,
                loading: false,
                reservationSaving: false,
                saveReservations: action.payload
            };

        case SAVE_RESERVATION_FAILURE:
            return { ...state, loading: false, reservationSaving: false, error: action.payload };

        case SAVE_BILL_REQUEST:
            return { ...state, loading: true };

        case SAVE_BILL_SUCCESS:
            return {
                ...state,
                loading: false,
                savedBill: action.payload
            };

        case SAVE_BILL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case RESET_SAVED_BILL:
            return {
                ...state,
                savedBill: null
            };

        case FETCH_BILL_REQUEST:
            return { ...state, loading: true };

        case FETCH_BILL_SUCCESS:
            return {
                ...state,
                bill: action?.payload,
                redirectTo: action.payload.redirectTo,
                loading: false
            };

        case FETCH_BILLS:
            return { ...state, loading: true };

        case FETCH_BILLS_SUCCESS:
            return {
                ...state,
                bills: action?.payload,
                redirectTo: action.payload.redirectTo,
                loading: false
            };

        case FETCH_BILL_ITEM:
            return { ...state, loading: true };

        case 'CLEAN_BILL_ITEM':
            return { ...state, billItem: null };

        case FETCH_BILL_ITEM_SUCCESS:
            return {
                ...state,
                billItem: action?.payload,
                redirectTo: action.payload.redirectTo,
                loading: false
            };

        case PLACE_ORDER_SUCCESS:
            return{
                ...state,
                redirectTo: action.payload.redirectTo,
            };

        case FETCH_TAX_REQUEST:
        case UPDATE_TAX_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_TAX_SUCCESS:
        case UPDATE_TAX_SUCCESS:
            return {
                ...state,
                loading: false,
                tax: action.payload
            };

        case FETCH_TAX_FAILURE:
        case UPDATE_TAX_FAILURE: return {
            ...state,
            loading: false,
            error: action.payload
        };

        case CHANGE_PASSWORD:
            return {
                ...state,
                loading: true,
                error: null
            };

        case UPDATE_RESTAURANT_PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case UPDATE_RESTAURANT_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                restaurant: action.payload
            };

        case UPDATE_RESTAURANT_PROFILE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case UPDATE_TABLE_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_TABLE_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                tables: action.payload
            };

        case UPDATE_TABLE_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case FETCH_DASHBOARD:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_DASHBOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                dashboard: action.payload
            };
        case FETCH_RESTAURANT_DETAIL_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_RESTAURANT_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                restaurant: action.payload
            };
        case FETCH_RESTAURANT_DETAIL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case EDIT_TABLE_SUCCESS:
            return {
                ...state,
                tableSaving: false,
                tables: action.payload,
                loading: false,
                error: null
            };

        case EDIT_TABLE_FAILURE:
            return {
                ...state,
                tableSaving: false,
                loading: false,
                error: action.payload
            };

        case ADD_TABLE_NUMBER:
            return {
                ...state,
                tableSaving: true,
                error: null
            };

        case ADD_TABLE_NUMBER_SUCCESS:
            return {
                ...state,
                tableSaving: false,
                tables: [
                    ...(Array.isArray(state.tables) ? state.tables : []),
                    ...(Array.isArray(action.payload) ? action.payload : [action.payload])
                ]
            };



        case ADD_TABLE_NUMBER_FAILURE:
            return {
                ...state,
                tableSaving: false,
                error: action.payload
            };

        case EDIT_TABLE:
            return {
                ...state,
                tableSaving: true,
                error: null
            };

        case FETCH_TABLES:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_TABLES_WITH_OTP:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_TABLES_SUCCESS:
            console.log('----- fetch table payload', action.payload);
            return {
                ...state,
                loading: false,
                tables: action.payload,   // ✅ keep it as array
                error: null
            };

        case FETCH_TABLES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // reducer.js
        case DELETE_TABLE_SUCCESS:
            return {
                ...state,
                tables: state.tables.filter(
                    (t) => t.restaurantTableId !== action.payload
                ),
                deleteSaving: false,
                deleteError: null,
                loading: false,
                error: null
            };

        case DELETE_TABLE_FAILURE:
            return {
                ...state,
                deleteSaving: false,
                deleteError: action.payload,
                loading: false,
                error: action.payload
            };


        case FETCH_LIVE_ORDER_SUCCESS:
            console.log(state, '----- live order status');
            return {
                ...state,
                liveOrder: action.payload
            };

        case FETCH_LIVE_ORDER_FAILURE:
            return {
                ...state,
                liveOrder: {},
                error: action.payload
            };

        case FETCH_ORDER_HISTORY:
            console.log(state, '----- HISTORY order status');
            return {
                ...state,
                orderHistory: action?.payload
            };

        case FETCH_ORDER_HISTORY_BY_TABLEOTP:
            console.log(state, '----- HISTORY order by tableotp');
            return {
                ...state,
                orderHistory: action?.payload
            };

        case FETCH_ORDER_HISTORY_SUCCESS:
            console.log(state, '----- HISTORY order status');
            return {
                ...state,
                orderHistory: Array.isArray(action.payload) ? action.payload : [action.payload]
            };

        case FETCH_ORDER_HISTORY_FAILURE:
            return {
                ...state,
                orderHistory: {},
                error: action.payload
            };

        case FETCH_CANCEL_ORDER:
            console.log(state, '----- cancelled order status');
            return {
                ...state,
                cancelledOrder: action?.payload
            };

        case FETCH_CANCEL_ORDER_SUCCESS:
            console.log(state, '----- HISTORY order status');
            return {
                ...state,
                cancelledOrder: Array.isArray(action.payload) ? action.payload : [action.payload]
            };

        case FETCH_CANCEL_ORDER_FAILURE:
            return {
                ...state,
                cancelledOrder: {},
                error: action.payload
            };

        // case UPDATE_ORDER_STATUS:
        //     console.log(state, '----- update order status');
        //     return {
        //         ...state,
        //         liveOrder: action?.payload
        //     };

        case UPDATE_ORDER_STATUS_SUCCESS:
            return {
                ...state,
                liveOrder: action.payload
            };

        case UPDATE_ORDER_STATUS_FAILURE:
            return {
                ...state,
                liveOrder: {},
                error: action.payload
            };

        case UPDATE_ITEM_STATUS_MENU:
            console.log(state, '----- status');
            return {
                ...state,
                updateStatus: { ...state.updateStatus, [action.payload.menuId]: action.payload }
            }
        case UPDATE_ITEM_MENU:

            console.log('------------------upadting - ', state.update, action.payload);
            return {
                ...state,
                update: { ...action.payload }
            }
        case API_FETCH_MENU_iTEM_SUCCESS:
            console.log('-------------success triggered', action.payload);
            return {
                ...state, foodItems: {
                    ...action.payload
                }
            }
        case REMOVE_ITEM_MENU_SUCCESS:
            console.log('-------------success DELETE triggered', action.payload);
            const updatedFoodItems = Object.values(state.foodItems || {}).filter(
                (item) => item?.menuId !== action.payload
            );
            return {
                ...state,
                foodItems: updatedFoodItems,
                deleteSaving: false,
                deleteError: null
            }

   

        
        case EDIT_MENU_ITEM:
            console.log("EDIT_MENU_ITEM reducer", action.payload)
            return {
                ...state,
                edit: action.payload,
                menuItemSaveError: null
            }
        case ADD_MENU_ITEM:
        case UPDATE_MENU_ITEM:
            return {
                ...state,
                menuItemSaving: true,
                menuItemSaveError: null
            }
        case ADD_ITEM_MENU_SUCCESS:
            console.log('-------------success triggered', action.payload);
            const foodItemsAfterAdd = Object.values(state.foodItems || {}).filter(
                (item) => item?.menuId !== action.payload?.menuId
            );
            return {
                ...state,
                menuItemSaving: false,
                menuItemSaveError: null,
                foodItems: [...foodItemsAfterAdd, action.payload]
            }
        case EDIT_MENU_ITEM_SUCCESS:
            console.log('-------------success triggered', action.payload);
            const foodItemsAfterEdit = Object.values(state.foodItems || {});
            const updatedItemExists = foodItemsAfterEdit.some(
                (item) => item?.menuId === action.payload?.menuId
            );
            return {
                ...state,
                menuItemSaving: false,
                menuItemSaveError: null,
                foodItems: updatedItemExists
                    ? foodItemsAfterEdit.map((item) => item?.menuId === action.payload?.menuId ? action.payload : item)
                    : [...foodItemsAfterEdit, action.payload],
                edit: {} // clear edit form
            }

        case FETCH_USERS_SUCCESS:
            console.log('-------------success triggered', action.payload);
            return {
                ...state, users: {
                    ...action.payload
                }
            }
        case ADD_USER:
        case UPDATE_USER:
            return { ...state, userSaving: true }
        case ADD_USER_SUCCESS:
            console.log('-------------success triggered', action.payload);
            return {
                ...state, userSaving: false, users: {
                    ...state.users,
                    [action.payload.id]: {
                        ...action.payload,
                    }
                }
            }
        case DELETE_USER_SUCCESS:
            console.log('-------------success DELETE triggered', action.payload);
            const updatedUsers = { ...state.users };
            delete updatedUsers[action.payload];
            return {
                ...state,
                users: updatedUsers,
                deleteSaving: false,
                deleteError: null
            }
        case EDIT_USER:
            return {
                ...state,
                edit: action.payload
            }
        case EDIT_USER_SUCCESS:
            return {
                ...state,
                userSaving: false,
                users: {
                    ...action.payload  // update by userId
                },
                edit: {} // clear edit form
            }
        case SAVE_MENU_ITEM_FAILURE:
            return {
                ...state,
                menuItemSaving: false,
                menuItemSaveError: action.payload
            }
        case SAVE_USER_FAILURE:
            return { ...state, userSaving: false, error: action.payload }
        case EDIT_CATEGORY:
            return {
                ...state,
                edit: action.payload
            }
        case ADD_CATEGORY:
        case UPDATE_CATEGORY:
            return { ...state, categorySaving: true }
        case EDIT_CATEGORY_SUCCESS:
            return {
                ...state,
                categorySaving: false,
                categories: {
                    ...action.payload  // update by userId
                },
                edit: {} // clear edit form
            }
        case ADD_CATEGORY_SUCCESS:
            console.log('-------------success triggered', action.payload);
            return {
                ...state, categorySaving: false, categories: {
                    ...state.categories,
                    [action.payload.id]: {
                        ...action.payload,
                    }
                }
            }
        case SAVE_CATEGORY_FAILURE:
            return { ...state, categorySaving: false, error: action.payload }
        case DELETE_CATEGORY_SUCCESS:
            console.log('-------------success DELETE triggered', action.payload);
            const updatedcategories = { ...state.categories };
            delete updatedcategories[action.payload];
            return {
                ...state,
                categories: updatedcategories,
                deleteSaving: false,
                deleteError: null
            }
        case FETCH_CATEGORIES_SUCCESS:
            console.log('-------------success triggered', action.payload);
            return {
                ...state, categories: {
                    ...action.payload
                }
            }
        //FETCH_CATEGORIES
        // Action to load users (e.g., after fetching from an API)
        // case setUsers:
        //     return state.users = action.payload;
        // You could add more reducers here for editUser, deleteUser, etc.
        // case GENERATE_LOGIN_OTP_SUCCESS:
        //     return {
        //         ...state,
        //         flags: { ...state.flags, otpGenerated: true, otpForPhone: action?.payload }, 
        //         loading: false
        //     }

        case SEND_LOGIN_OTP:
            return {...state,loading: true}

        // case SEND_LOGIN_OTP_SUCCESS:
        //     return produce(state, draft => {
        //         delete draft.flags.otpGenerated;
        //         draft.flags = { ...state.flags, otpSuccess: true };
        //         draft.loading = false
        //     });

            case SEND_LOGIN_OTP_SUCCESS:
            console.log("SEND_LOGIN_OTP_SUCCESS",action.payload)
            return produce(state, draft => {
                if( action.payload === true)
                delete draft.flags.otpGenerated;
                draft.flags = { ...state.flags, otpSuccess: action.payload , otpError:  action.payload === false ? "OTP is incorrect": undefined  };
                draft.loading = false
            });
        default:
            return state;
    }

}

export default reducers;
